import * as React from 'react';
import { Emoji } from '../Emoji';
import * as animations from '@styles/_animations.scss';

export const Vampire = (props: { text?: string }) => (
  <div
    className={[animations.animated, animations.bounceInLeft].join(' ')}
    style={{ position: 'absolute', bottom: '-1%', left: '40%', zIndex: 20 }}
  >
    <Emoji name={Emoji.EmojiNames.Vampire} size={200} text={'Trick or Treat!'} />
  </div>
);



// WEBPACK FOOTER //
// ./src/common/components/emoji/_components/Vampire.tsx